export default __webpack_public_path__ + "static/media/logo-responsive.ed1b03ca.png";